export const actionTypes = {
	SET_PENDING_FILE: 'SET_PENDING_FILE',
	UPDATE_PENDING_FILE: 'UPDATE_PENDING_FILE',
	INITIALIZE: 'INITIALIZE'
}